import Loading from '../Loading/Loading';
import React, { FC } from 'react';
import Show from '../Show/Show';
import { ActivePath } from './ActivePath';
import { Body1Bold } from '../../config/designSystem/typography';
import {  CheckIconPath, SIZE_WHITE_CIRCLE } from './CheckIconPath';
import { HEIGHT_PATH_FN, WIDTH_PATH_FN } from '../../config/designSystem/Layout';
import { HEIGHT_PROGRESS_BAR, ProgressBarPath } from './ProgressBarPath';
import { PathImage } from './PathImage';
import { SPACING } from '../../config/designSystem/Spacing';
import { TouchableOpacity, View} from 'react-native';
import { observer } from 'mobx-react';
import { useAvailableDimensions } from '../../hooks/ui/useAvailableDimensions';
import { useStores } from '../../hooks/useStores';

type PathCardProp = {
  id: string;
  onPress: () => void;
  small?: boolean;
};

const _PathCard : FC<PathCardProp>= ({id, onPress, small}) => {



  const rootStore = useStores();
  const smallRatio = 0.85;

  const { width } = useAvailableDimensions();
  const WIDTH_PATH = small ? smallRatio * WIDTH_PATH_FN(width) : WIDTH_PATH_FN(width);
  const HEIGHT_IMAGE = small ? smallRatio* HEIGHT_PATH_FN(width) : HEIGHT_PATH_FN(width);
  const MARGIN_LEFT_TEXT = 10;
  const path = rootStore?.path?.getPath(id);



  if(!path) return <Loading />;

  const { title, status, wasThePathAlreadyCompleted: isFinished}= path;
  const isStarted = status === 'started';
  const readPercentage = path?.readPercentage();
  const isFinishedState = isFinished && !isStarted;
  const isActive = path?.isActive();
  const leftValue = SPACING['sp-8'];

  return (
    <TouchableOpacity onPress={onPress} style={{
      rowGap: SPACING['sp-8']
    }}>
      <Show when={isFinishedState}>
        <View style={{position:'absolute', left:(WIDTH_PATH-SIZE_WHITE_CIRCLE)/2, top:(HEIGHT_IMAGE-SIZE_WHITE_CIRCLE)/2, zIndex:4  }}>
          <CheckIconPath />
        </View>
      </Show>
      <PathImage id={id} width={WIDTH_PATH} height={HEIGHT_IMAGE} style={isFinishedState && {opacity:0.7}}>
        <Show when={isActive}>
          <View style={{position:'absolute', top:SPACING['sp-8'], left: leftValue }}>
            <ActivePath />
          </View>
        </Show>
        <Show when={isStarted}>
          <View style={{position:'absolute', bottom:SPACING['sp-8']+HEIGHT_PROGRESS_BAR, left: leftValue }}>
            <ProgressBarPath readPercentage={readPercentage as number} width={(WIDTH_PATH - 2*SPACING['sp-8'])} />
          </View>
        </Show>
      </PathImage>
      <View style={{maxWidth: WIDTH_PATH - MARGIN_LEFT_TEXT, marginLeft: MARGIN_LEFT_TEXT}}>
        <Body1Bold>{title}</Body1Bold>
      </View>
    </TouchableOpacity>
  );
};

export const PathCard = observer(_PathCard);
